import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UserCard } from 'src/app/model/card/user-card';
import { NoteSection } from 'src/app/model/section/note-section';
import { Banner } from 'src/app/model/shared/banner';

declare function homeSlider(): any;

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss']
})
export class UserCardComponent implements OnInit {
  @Input() banner: Banner = {} as Banner;
  @Input() userCards: UserCard[] = [];
  @Input() noteSections: NoteSection[] = [];
  constructor() {}

  ngOnInit(): void {
    homeSlider();
  }
}
